import { useQuery } from '@tanstack/react-query';
import { INCIDENT_V2_TICKETS } from '@elementary/common-ui/constants/queryKeys';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import useFlags from 'shared/hooks/useFlags';
import { fetchIncidentV2Tickets } from '../api';
import type { IncidentV2TicketRow } from '../types';

type Props = {
  incidentId?: string;
  enabled?: boolean;
};

const useIncidentV2Tickets = ({ incidentId, enabled = true }: Props) => {
  const selectedEnvId = useSelectedEnv();
  const { hasFlag } = useFlags();

  return useQuery<IncidentV2TicketRow[]>({
    queryKey: [INCIDENT_V2_TICKETS, selectedEnvId, incidentId],
    queryFn: () => fetchIncidentV2Tickets(selectedEnvId!, incidentId!),
    enabled: enabled && !!incidentId && !!selectedEnvId && hasFlag('ticketing'),
  });
};

export default useIncidentV2Tickets;
